import { connect } from "react-redux";
import Title from "../components/Title";
import { showMenu } from "../data/actions";

const mapStateToProps = state => ({

});

const mapDispatchToProps = dispatch => ({
	showMenu: (bool) => dispatch(showMenu(bool))
})

export default connect(mapStateToProps, mapDispatchToProps)(Title);


// WEBPACK FOOTER //
// ./src/containers/Title.js